<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
		{{TR "Rohwert schreiben"}}
	</h4>
</div>
<div class="modal-body">
	<div id="value-selection"></div>
	<ul id="js-errors" class="parsley-errors-list filled m-t-20" style="display: none">
		<li class="parsley-required">{{error}}</li>
	</ul>
	<div id="dataInput"></div>
	<div id="js-error-message" class="alert alert-danger invisible m-t-20">
		<strong>{{error}}</strong>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary disabled" id="js-save">{{TR "Schreiben"}}</button>
</div>
